import { cn } from "@v2/lib/utils";

export function MatchKpi({
  label,
  value,
  hint,
  accent,
}: {
  label: string;
  value: string | number;
  hint?: string;
  accent?: string;
}) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="stat-label">{label}</span>
      <span className={cn("stat-value", accent)}>{value}</span>
      {hint && <span className="stat-hint">{hint}</span>}
    </div>
  );
}
